export default __webpack_public_path__ + "static/media/002-meat.3dc3d1ba.svg";